import {Modal} from 'react-bootstrap';
import React, { useState } from 'react';
import { eventService } from '../../Services/eventService';
import toast from 'react-hot-toast';

const EditImageModal = (props) => {
    const [image, setImage] = useState(props.image ?? {
        name: "",
        imagePath: "",
        maxx: "",
        maxy: "",
        minx: "",
        miny: ""
    });
    const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
        if (event.target.files[0]) {
            setFile(event.target.files[0]);
        } else {
            setFile(null);
        }
    };

    const save = () => {
        console.log(image);
        if(props.image != null) {
            eventService.updateImage(props.image.eventImageId, image.name, file, image.imagePath, image.maxx, image.maxy, image.minx, image.miny ).then((e) => {
                toast.success("Updated Image successfully");
                props.setShow(false);
                props.reload();
            }).catch((e) => {
                console.log(e);
                toast.error("Unable to update Image");
            });
        } else {
            eventService.addImage(props.eventId, image.name, file, image.imagePath, image.maxx, image.maxy, image.minx, image.miny).then((e) => {
                toast.success("Uploaded Image successfully");
                props.setShow(false);
                props.reload();
            }).catch((e) => {
                console.log(e);
                toast.error("Unable to Upload Image");
            });
        }
    };

    console.log(props.image, image);

    return (
            <Modal
                show={() => props.setShow(true)}
                onHide={() => props.setShow(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName=""
                className="member-edit-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5>Add/Edit Image</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>Name: <input type="text" value={image?.name} onChange={(e) => setImage({...image, name: e.target.value})}/></div>
                        <div>Image Path: <input type="text" value={image?.imagePath} onChange={(e) => setImage({...image, imagePath: e.target.value})}/></div>
                        <div>Maxx: <input type="text" value={image?.maxx} onChange={(e) => setImage({...image, maxx: e.target.value})}/></div>
                        <div>Maxy: <input type="text" value={image?.maxy} onChange={(e) => setImage({...image, maxy: e.target.value})}/></div>
                        <div>Minx: <input type="text" value={image?.minx} onChange={(e) => setImage({...image, minx: e.target.value})}/></div>
                        <div>Miny: <input type="text" value={image?.miny} onChange={(e) => setImage({...image, miny: e.target.value})}/></div>
                        <div>
                            Image: <input type="file" className="upload-input" onChange={handleFileChange} accept=".jpg,.png,.gif" />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline" onClick={() => props.setShow(false)}>CANCEL</button>
                    <button type="button" className='btn btn-primary ml-auto submit-btn' onClick={()=>save()}>SAVE</button>
                </Modal.Footer>
            </Modal>
    );
}

export default EditImageModal;